import {
  call, put, select, takeLatest,
} from 'redux-saga/effects';
import { toast } from 'react-toastify';
import {
  setCommonAction, setSimpleValidarProcessoAction,
} from './ValidarProcesso.store';
import {
  SET_BUSCAR_DADOS_TABELA,
  SET_EXPORTAR_VALIDACAO_PROCESSOS,
  SET_PROXIMA_FASE_PROCESSO,
} from './ValidarProcesso.constants';
import ValidarProcessoService from '../../services/core/validarProcesso/ValidarProcessoService';
import { downloadFileSispag } from '../../helpers';

function* successPesquisarValidarProcesso(data) {
  yield put(setSimpleValidarProcessoAction('tableView', data.data.content));
  yield put(setSimpleValidarProcessoAction('totalElements', data.data.totalElements));
  yield put(setSimpleValidarProcessoAction('rowsPerPage', data.data.pageable.pageSize));
  yield put(setSimpleValidarProcessoAction('page', data.data.pageable.pageNumber));
}

function* emptyPesquisaValidarProcesso() {
  yield put(setSimpleValidarProcessoAction('tableView', []));
  yield put(setSimpleValidarProcessoAction('totalElements', 0));
}

function* buscarDadosTabelaHandler(actions) {
  yield put(setCommonAction('loadingPage', true));
  const page = yield select(states => states.page);
  const rowsPerPage = yield select(states => states.rowsPerPage);
  const columnOrdenacao = yield select(states => states.columnOrdenacao);
  const listIds = yield select(states => states.listIds);
  const storedListIds = new Map();

  try {
    const order = [`${columnOrdenacao.element},${columnOrdenacao.order}`];
    const response = yield call(ValidarProcessoService.buscarInfoValidarProcesso, { page, size: rowsPerPage }, order);
    yield successPesquisarValidarProcesso(response);
    if (actions.atualizarListaIds === true) {
      const responseIds = yield call(ValidarProcessoService.buscarIdsProcessos);
      Object.keys(listIds).forEach((key) => {
        storedListIds.set(parseInt(key, 10), listIds[key]);
      });
      const ids = responseIds.data.reduce((acumulador, id) => ({ ...acumulador, [id]: false }), {});
      yield put(setSimpleValidarProcessoAction('listIds', ids));
    }
  } catch (e) {
    yield emptyPesquisaValidarProcesso();
  } finally {
    yield put(setCommonAction('loadingPage', false));
  }
}

function* exportarValidacaoProcessosHandler() {
  yield put(setCommonAction('loadingPage', true));
  try {
    const response = yield call(ValidarProcessoService.exportarValidacaoProcessos);
    if (response.data.length > 0) {
      downloadFileSispag(response.headers.filename, response.data);
    } else {
      toast.info('Nenhum processo encontrado para exportação.');
    }
  } catch (e) {
    toast.error('Erro ao gerar o Excel. Tente novamente mais tarde.');
  } finally {
    yield put(setCommonAction('loadingPage', false));
  }
}

function* proximaFaseProcessoHandler() {
  yield put(setCommonAction('loadingPage', true));
  const listIds = yield select(states => states.listIds);

  try {
    yield call(ValidarProcessoService.proximaFaseProcesso, Object.keys(listIds).filter(key => listIds[key] === true).map(key => Number(key)));
    yield call(buscarDadosTabelaHandler, { atualizarListaIds: true });
    toast.success('Processos enviados para a próxima fase com sucesso.');
  } catch (e) {
    toast.error('Erro ao enviar os processos para a próxima fase.');
  } finally {
    yield put(setCommonAction('loadingPage', false));
  }
}

export const buscarDadosTabelaAction = atualizarListaIds => ({
  type: SET_BUSCAR_DADOS_TABELA,
  atualizarListaIds,
});

export const exportarValidacaoProcessosAction = () => ({
  type: SET_EXPORTAR_VALIDACAO_PROCESSOS,
});

export const proximaFaseProcessoAction = () => ({
  type: SET_PROXIMA_FASE_PROCESSO,
});

export default function* watchValidarProcesso() {
  yield takeLatest(SET_BUSCAR_DADOS_TABELA, buscarDadosTabelaHandler);
  yield takeLatest(SET_EXPORTAR_VALIDACAO_PROCESSOS, exportarValidacaoProcessosHandler);
  yield takeLatest(SET_PROXIMA_FASE_PROCESSO, proximaFaseProcessoHandler);
}
